import { useTranslation } from "react-i18next"
import { TFunction } from "i18next"

export default (isAdmin?: boolean) => {
	const { t } = useTranslation("transactions", { keyPrefix: "form.dataTableHeaders" })

	return isAdmin !== undefined ? columns(t).filter(c => isAdmin || !c.needsAdmin) : columns(t)
}

const columns = (t: TFunction) => [
	{
		key: "id",
		title: "ID",
		dataIndex: "id",
		sorteable: true,
		width: "4rem"
	},
	{
		key: "invoiceId",
		title: t("invoiceId"),
		dataIndex: "invoiceId",
		sorteable: true,
		width: "4rem"
	},
	{
		key: "userEmail",
		title: t("userEmail"),
		dataIndex: "userEmail",
		align: "center",
		width: "12rem",
		ellipsis: true
	},
	{
		key: "userName",
		title: t("userName"),
		dataIndex: "userName",
		align: "center",
		width: "10rem",
		ellipsis: true
	},
	{
		key: "site",
		title: t("site"),
		dataIndex: "site",
		align: "center",
		width: "10rem"
	},
	{
		key: "micrositeType",
		title: t("micrositeType"),
		dataIndex: "micrositeType",
		width: "10rem",
		align: "center"
	},
	{
		key: "serviceName",
		title: t("serviceName"),
		dataIndex: "serviceName",
		width: "12rem",
		ellipsis: true
	},
	{
		key: "serviceId",
		title: t("serviceId"),
		dataIndex: "serviceId",
		width: "6rem",
		align: "center"
	},
	{
		key: "sessionName",
		title: t("sessionName"),
		dataIndex: "sessionName",
		width: "8rem",
		ellipsis: true
	},
	{
		key: "sellerId",
		title: t("sellerId"),
		dataIndex: "sellerId",
		align: "center",
		width: "8rem",
		ellipsis: true
	},
	{
		key: "sellerNIF",
		title: t("sellerNIF"),
		dataIndex: "sellerNIF",
		align: "center",
		width: "8rem",
		ellipsis: true
	},
	{
		key: "sellerName",
		title: t("sellerName"),
		dataIndex: "sellerName",
		align: "center",
		width: "8rem",
		ellipsis: true
	},
	{
		key: "appointmentStatus",
		title: t("appointmentStatus"),
		dataIndex: "appointmentStatus",
		align: "center",
		width: "8rem"
	},
	{
		key: "date",
		title: t("date"),
		dataIndex: "date",
		width: "8rem"
	},
	{
		key: "appointmentDate",
		title: t("appointmentDate"),
		dataIndex: "appointmentDate",
		align: "center",
		width: "8rem"
	},
	{
		key: "finalPrice",
		title: t("finalPrice"),
		dataIndex: "finalPrice",
		width: "8rem",
		align: "center"
	},
	{
		key: "usedCredits",
		title: t("usedCredits"),
		dataIndex: "usedCredits",
		width: "8rem",
		align: "center"
	},
	{
		key: "units",
		title: t("units"),
		dataIndex: "units",
		width: "6rem",
		align: "center"
	},
	{
		key: "sellerFee",
		title: t("sellerFee"),
		dataIndex: "sellerFee",
		width: "6rem",
		align: "center"
	},
	{
		key: "total",
		title: t("total"),
		dataIndex: "total",
		width: "5rem",
		align: "center"
	},
	{
		key: "cancelledAt",
		title: t("cancellationDate"),
		dataIndex: "cancelledAt",
		width: "10rem"
	},
	{
		title: "",
		key: "editButton",
		dataIndex: "editButton",
		needsAdmin: true,
		width: "3rem"
	}
]
